module.exports = __webpack_public_path__ + "img/contactus.71649fcc.jpg";